export const GET_TOURS = 'get_tours';
export const GET_TOUR = 'get_tour';
export const ADD_TOUR = 'add_tour';
export const CLEAR_NEW_TOUR = 'clear_new_tour';
export const UPDATE_TOUR = 'update_tour';
export const DELETE_TOUR = 'delete_tour';
export const CLEAR_TOUR = 'clear_tour';

export const GET_USERS = 'get_users';
export const LOGIN_USER = 'login_user';
export const USER_AUTH = 'user_auth';
export const USER_REGISTER = 'user_register';



// WEBPACK FOOTER //
// ./src/redux/actions/types.js